import {lazy} from 'react';

const PayPalPaymentComponent = lazy(() => import(/* webpackChunkName: "PayPalPaymentComponent" */ './PayPalPayment'));

const PayPalSuccessPage = lazy(() => import(/* webpackChunkName: "PayPalSuccessPage" */ './PayPalSuccessPage'));

export default [
    {
        name: 'paypal.payment',
        path: '/paypal/payment',
        exact: true,
        isPublic: false,
        layout: {
            header: true,
            footer: false,
            sidebar: true,
            minimal: false,
        },
        component: PayPalPaymentComponent,
        routeScopes: ['crud_user_payments'],
    },
    {
        name: 'paypal.success',
        path: '/paypal/success/:credits?/:total?/:symbol/:currency?/:order_id?',
        exact: true,
        isPublic: false,
        layout: {
            header: true,
            footer: false,
            sidebar: true,
            minimal: false,
        },
        component: PayPalSuccessPage,
        routeScopes: ['crud_user_payments'],
    }
];
